var map = {
	"./22/icon-airdrop.png": 56877,
	"./22/icon-boost.png": 98850,
	"./22/icon-coin.png": 13422,
	"./22/icon-frends.png": 6099,
	"./22/icon-home.png": 98392,
	"./22/icon-learderboard.png": 30754,
	"./car/icon-airdrop.png": 32236,
	"./car/icon-coin-sign.png": 15644,
	"./car/icon-coin.png": 45429,
	"./car/icon-frends.png": 23151,
	"./car/icon-home.png": 98236,
	"./car/icon-learderboard.png": 3624,
	"./car/icon-tasks.png": 79252,
	"./human/icon-airdrop.png": 11748,
	"./human/icon-coin-sign.png": 96296,
	"./human/icon-coin.png": 68356,
	"./human/icon-frends.png": 23303,
	"./human/icon-home.png": 78611,
	"./human/icon-learderboard.png": 28058,
	"./human/icon-tasks.png": 1549
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87473;